module.exports = __webpack_public_path__ + "img/wolverhampton-wanderers-logo-icon.58bcdb5b.png";